import { render, staticRenderFns } from "./SdkInformation.vue?vue&type=template&id=5e504adf"
import script from "./SdkInformation.vue?vue&type=script&lang=js"
export * from "./SdkInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports